import Meaning from '../components/Meaning'

import '../styles/Favourites.css'
export default function Favourites() {
  
   const storedFavs = JSON.parse(localStorage.getItem("my_words") ); //get them back


  return (
    <div className='Favourites'>
        <h1>Favourites</h1>
        <div className='Favourites-container'>
          {storedFavs && 
            storedFavs.length > 0 ? storedFavs.map((fav,index) => {
            return <Meaning word={fav} index={index} key={index}></Meaning>
            }) : <div>No favourites</div>
          }
          
        </div>
        
    </div>
  )
}
